var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / TJ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-TJ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#D9101C",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0F7811",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9.33333333 C14.3681898,9.33333333 14.6666667,9.63181017 14.6666667,10 C14.6666667,10.1204477 14.6347245,10.3761244 14.5788491,10.6656639 L15.3394814,10.6666667 C15.6711126,10.6666667 15.9456611,10.9112203 15.9928383,11.2342396 L16,11.3333333 C16,11.7015232 15.6993499,12 15.3394814,12 L12.6605186,12 C12.2957243,12 12,11.7040901 12,11.3333333 C12,10.9651435 12.3006501,10.6666667 12.6605186,10.6666667 L13.4211509,10.6656639 C13.3652755,10.3761244 13.3333333,10.1204477 13.3333333,10 C13.3333333,9.63181017 13.6318102,9.33333333 14,9.33333333 Z M18,9.33333333 C18.3681898,9.33333333 18.6666667,9.63181017 18.6666667,10 C18.6666667,10.3681898 18.3681898,10.6666667 18,10.6666667 C17.6318102,10.6666667 17.3333333,10.3681898 17.3333333,10 C17.3333333,9.63181017 17.6318102,9.33333333 18,9.33333333 Z M10,9.33333333 C10.3681898,9.33333333 10.6666667,9.63181017 10.6666667,10 C10.6666667,10.3681898 10.3681898,10.6666667 10,10.6666667 C9.63181017,10.6666667 9.33333333,10.3681898 9.33333333,10 C9.33333333,9.63181017 9.63181017,9.33333333 10,9.33333333 Z M12.6666667,8 C13.0348565,8 13.3333333,8.29847683 13.3333333,8.66666667 C13.3333333,9.0348565 13.0348565,9.33333333 12.6666667,9.33333333 C12.2984768,9.33333333 12,9.0348565 12,8.66666667 C12,8.29847683 12.2984768,8 12.6666667,8 Z M15.3333333,8 C15.7015232,8 16,8.29847683 16,8.66666667 C16,9.0348565 15.7015232,9.33333333 15.3333333,9.33333333 C14.9651435,9.33333333 14.6666667,9.0348565 14.6666667,8.66666667 C14.6666667,8.29847683 14.9651435,8 15.3333333,8 Z",
    id: "Oval-36",
    fill: "#FAD14E",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/TJ.18845d0ce444a371293e8b7e4786bf25.svg";
export { ForwardRef as ReactComponent };